import { PointAddResponse } from "@1games-ru/region-shared/dist/client/requests/point";

export const pointToPoint = (point: PointAddResponse) => ({
  position: point.position,
  heading: point.heading,
});
